import router from '../router/index'
import store from '../store/index'
import { TRACKING_EVENTS, TRACKING_EVENTS_INFO } from '../enum/tracking'
import Vue from 'vue'

export default function initAnalytics() {
  const trackers = initTrackingPlatforms()

  onPageChange(trackers)

  Vue.prototype.$analytics = function (eventType, data) {
    sendCustomEvent(eventType, data, trackers)
  }

  function sendAsyncAnalytics(url, method = 'GET') {
    try {
      fetch(url, {
        method,
        mode: 'cors',
        keepalive: true,
      })
    } catch (e) {
      //Catch not supported error
    }
  }

  function initTrackingPlatforms() {
    const gaKey = store.getters['gaKey'] // TODO get from store widget options
    let gaEnabled = false

    if (gaKey) {
      googleAnalyticsScript()
      // eslint-disable-next-line no-undef
      ga('create', gaKey, 'auto')
      gaEnabled = true
    }

    return { gaEnabled }
  }

  function onPageChange(trackers) {
    const { gaEnabled } = trackers
    /*
    ** Every time the route changes (fired on initialization too)
    */
    // eslint-disable-next-line no-unused-vars
    router.afterEach(async function (to, from) {

      if (window.ga && gaEnabled) {
        // eslint-disable-next-line no-undef
        ga('set', { page: to.path, title: to.name })
        // eslint-disable-next-line no-undef
        ga('send', 'pageview')
      }
      // Mounted hook in JobDetails is called 2 times (a nuxt bug); Because of that this action can't be done there
      if (to.name.includes('job-details')) {
        await store.dispatch('getJobs')
        const job = store.getters['getJobById'](to.params.slug)
        const analyticsData = {
          eventLabel: job[0].uuid,
          job
        }

        sendCustomEvent(TRACKING_EVENTS.JOB_VIEW, analyticsData, trackers)
      }
    })
  }

  function sendCustomEvent(eventType, data = {}, { gaEnabled }) {
    const { eventAction, eventCategory } = TRACKING_EVENTS_INFO[eventType]
    const { eventLabel, eventValue } = data
    const { pixelUrl, externalLink } = data.config || {}

    if (gaEnabled && window.ga) {
      const transportOption = externalLink ? { transport: 'beacon' } : {}

      // eslint-disable-next-line no-undef
      ga('send', 'event', {
        eventCategory,
        eventAction,
        eventLabel,
        eventValue,
        ...transportOption
      })
    }

    if (pixelUrl) {
      sendAsyncAnalytics(pixelUrl)
      if (externalLink) {
        window.open(eventLabel, '_self', '')
      }
    }
  }

  /* eslint-disable */
  function googleAnalyticsScript() {
    (function (i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r
      i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments)
      }, i[r].l = 1 * new Date()
      a = s.createElement(o),
        m = s.getElementsByTagName(o)[0]
      a.async = 1
      a.src = g
      m.parentNode.insertBefore(a, m)
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga')
  }
}


